module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-relax-gaming.1983b4e6.png";